/* shto-k2-detail: the progress bar under the phone carousel follows the cards as they are swiped (assets/shto-swipe.js moves them). */
(function () {
  if (window.ShtoK2Detail) return;
  window.ShtoK2Detail = true;

  function init(section) {
    var track = section.querySelector('[data-shto-k2-track]');
    var bar = section.querySelector('[data-shto-k2-progress]');
    var thumb = bar && bar.firstElementChild;
    if (!track || !thumb || track.shtoK2) return;
    track.shtoK2 = true;
    var frame = 0;
    function update() {
      frame = 0;
      var max = track.scrollWidth - track.clientWidth;
      var progress = max > 0 ? Math.min(1, Math.max(0, track.scrollLeft / max)) : 0;
      thumb.style.transform = 'translateX(' + (progress * (bar.clientWidth - thumb.offsetWidth)).toFixed(2) + 'px)';
    }
    function queue() { if (!frame) frame = requestAnimationFrame(update); }
    track.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    update();
  }

  function initAll(root) { (root || document).querySelectorAll('[data-shto-section="shto-k2-detail"]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
